import { lazy } from "react";

const SystemMediaPage = lazy(
  () => import("@/widgets/system-admin/media/MediaPage"),
);

const SystemMediaRoutes = {
  path: "media",
  children: [{ index: true, element: <SystemMediaPage /> }],
};

export default SystemMediaRoutes;
